import { render } from "./Jiangli.vue?vue&type=template&id=8604fe92&scoped=true&ts=true"
import script from "./Jiangli.vue?vue&type=script&lang=ts"
export * from "./Jiangli.vue?vue&type=script&lang=ts"

import "./Jiangli.vue?vue&type=style&index=0&id=8604fe92&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8604fe92"]])

export default __exports__